import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f8b7054"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["infinite-scroll-disabled"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "flexBothEnds" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("USDT ")
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "flexBothEnds title" }
const _hoisted_8 = { class: "fontBright fontSize15" }
const _hoisted_9 = { class: "flexBothEnds marT10" }
const _hoisted_10 = { class: "avatar" }
const _hoisted_11 = { class: "name" }
const _hoisted_12 = { class: "fontSize13" }
const _hoisted_13 = {
  key: 0,
  class: "loadEnd"
}
const _hoisted_14 = {
  key: 1,
  class: "loadEnd"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_arrow_right = _resolveComponent("arrow-right")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_OrderDetails = _resolveComponent("OrderDetails")!
  const _component_OrderChat = _resolveComponent("OrderChat")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createBlock(_component_el_row, {
    class: "freeTradeRecord marT10",
    gutter: 20
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_col, { span: 8 }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", {
            class: "advertsItems scroll",
            "infinite-scroll-disabled": _ctx.isLoadEnd
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recordArr, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(['itemBox', { active: _ctx.itemBoxI == index }]),
                key: item.id,
                onClick: ($event: any) => (_ctx.onItemBox(item, index))
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", _hoisted_4, [
                    _createElementVNode("label", {
                      class: _normalizeClass({ fontBright: _ctx.isMySell(item.payUserId) })
                    }, _toDisplayString(_ctx.isMySell(item.payUserId) ? _ctx.langObj.l0018 : _ctx.langObj.l0017), 3),
                    _hoisted_5
                  ]),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.formatDateTime(item.createTime)), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.langObj.l0033 + "：" + item.amount.toFixed(6)) + "USDT", 1),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.Config.currency.symbol + item.totalCny.toFixed(2)), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.showName(item).substring(0, 1)), 1),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.showName(item)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.getClassName(item))
                    }, _toDisplayString(_ctx.getStatus(item.status)), 3),
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_arrow_right)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ], 10, _hoisted_2))
            }), 128)),
            (_ctx.isLoadStart)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.langObj.l0053), 1))
              : (!_ctx.isLoadStart && _ctx.isLoadEnd)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.langObj.l0054), 1))
                : _createCommentVNode("", true)
          ], 8, _hoisted_1), [
            [_directive_infinite_scroll, _ctx.onFreeTradeHistory]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_col, { span: 8 }, {
        default: _withCtx(() => [
          _createVNode(_component_OrderDetails, { ref: "orderDetails" }, null, 512)
        ]),
        _: 1
      }),
      _createVNode(_component_el_col, { span: 8 }, {
        default: _withCtx(() => [
          _createVNode(_component_OrderChat, { ref: "orderChat" }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}